import React, {Component} from "react"
import {filter} from "lodash"

import authentication from "@irati/auth"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray"
import {DealsTag} from "@irati/types"
import packageService from "@irati/deals/services/package"
import productSettingsService from "@irati/permissions/services/productSettings"
import ListWrapper from "./styled/ListWrapper"
import TagListItem from "./TagListItem"

interface Props {
  onSave: () => void
}

interface State {
  tags: DealsTag[]
  blacklistedTags: string[]
  load?: Promise<void>
}

export default class TagList extends Component<Props, State> {
  state: State = {
    tags: [],
    blacklistedTags: [],
    load: hangPromise()
  }

  componentDidMount() {
    const business = authentication.business()
    const load = productSettingsService.get(business.uuid, business.rootTeamId).then((ps) => {
      this.setState({blacklistedTags: ps.perksSettings?.blacklistedTags || []})
      return packageService.dealTagsForCurrentPackage().then((tags) => {
        this.setState({tags: filter(tags, (tag) => tag.filterable)})
      })
    })
    this.setState({load})
  }

  handleToggle = (uuid: string) => {
    const newBlacklistedTags = addOrRemoveFromArray(this.state.blacklistedTags, uuid)

    const business = authentication.business()
    return productSettingsService
      .updatePerkSettings(business.uuid, business.rootTeamId, {
        blacklistedTags: newBlacklistedTags
      })
      .then((ps) => {
        this.props.onSave()
        this.setState({blacklistedTags: ps.perksSettings?.blacklistedTags || []})
      })
  }

  isTagBlackListed = (uuid: string) => {
    return this.state.blacklistedTags.find((blacklistedTagUuid: string) => blacklistedTagUuid === uuid)
  }

  render() {
    const {tags, load} = this.state

    return (
      <ListWrapper>
        <Loading load={load}>
          {tags.map((tag) => (
            <TagListItem key={tag.uuid} tag={tag} blacklisted={!!this.isTagBlackListed(tag.uuid)} handleToggle={this.handleToggle} />
          ))}
        </Loading>
      </ListWrapper>
    )
  }
}
